export function syncModalScrollLockState(vm, shouldLock) {
  if (!vm || typeof document === "undefined" || typeof window === "undefined") return;
  const wrapper = document.querySelector(".wrapper");
  const mainPanel = document.querySelector(".main-panel");
  const body = document.body;

  if (shouldLock) {
    if (vm.isModalScrollLocked) return;
    const shouldFixBody =
      typeof window.matchMedia === "function"
        ? window.matchMedia("(max-width: 768px)").matches
        : false;

    vm.modalLockWrapper = wrapper || null;
    vm.modalLockWrapperTransform = vm.modalLockWrapper
      ? vm.modalLockWrapper.style.transform
      : "";
    vm.modalLockWrapperWebkitTransform = vm.modalLockWrapper
      ? vm.modalLockWrapper.style.webkitTransform
      : "";
    vm.modalLockMainPanel = mainPanel || null;
    vm.modalLockMainPanelOverflow = vm.modalLockMainPanel
      ? vm.modalLockMainPanel.style.overflow
      : "";
    vm.modalLockMainPanelScrollTop = vm.modalLockMainPanel
      ? vm.modalLockMainPanel.scrollTop
      : 0;
    vm.modalLockMainPanelTransform = vm.modalLockMainPanel
      ? vm.modalLockMainPanel.style.transform
      : "";
    vm.modalLockMainPanelWebkitTransform = vm.modalLockMainPanel
      ? vm.modalLockMainPanel.style.webkitTransform
      : "";
    vm.modalLockBodyOverflow = body ? body.style.overflow : "";
    vm.modalLockBodyPosition = body ? body.style.position : "";
    vm.modalLockBodyTop = body ? body.style.top : "";
    vm.modalLockBodyLeft = body ? body.style.left : "";
    vm.modalLockBodyRight = body ? body.style.right : "";
    vm.modalLockBodyWidth = body ? body.style.width : "";
    vm.modalLockBodyScrollY = window.scrollY || window.pageYOffset || 0;
    vm.modalLockBodyIsFixed = shouldFixBody;

    if (vm.modalLockWrapper && shouldFixBody) {
      vm.modalLockWrapper.style.transform = "none";
      vm.modalLockWrapper.style.webkitTransform = "none";
    }
    if (vm.modalLockMainPanel) {
      vm.modalLockMainPanel.style.overflow = "hidden";
      if (shouldFixBody) {
        vm.modalLockMainPanel.style.transform = "none";
        vm.modalLockMainPanel.style.webkitTransform = "none";
      }
      vm.modalLockMainPanel.scrollTop = vm.modalLockMainPanelScrollTop;
    }
    if (body) {
      body.style.overflow = "hidden";
      if (shouldFixBody) {
        body.style.position = "fixed";
        body.style.top = `-${vm.modalLockBodyScrollY}px`;
        body.style.left = "0";
        body.style.right = "0";
        body.style.width = "100%";
      }
    }
    vm.isModalScrollLocked = true;
    return;
  }

  if (!vm.isModalScrollLocked) return;
  if (vm.modalLockWrapper) {
    vm.modalLockWrapper.style.transform = vm.modalLockWrapperTransform;
    vm.modalLockWrapper.style.webkitTransform = vm.modalLockWrapperWebkitTransform;
  }
  if (vm.modalLockMainPanel) {
    vm.modalLockMainPanel.style.overflow = vm.modalLockMainPanelOverflow;
    vm.modalLockMainPanel.style.transform = vm.modalLockMainPanelTransform;
    vm.modalLockMainPanel.style.webkitTransform = vm.modalLockMainPanelWebkitTransform;
    vm.modalLockMainPanel.scrollTop = vm.modalLockMainPanelScrollTop;
  }
  if (body) {
    body.style.overflow = vm.modalLockBodyOverflow;
    if (vm.modalLockBodyIsFixed) {
      body.style.position = vm.modalLockBodyPosition;
      body.style.top = vm.modalLockBodyTop;
      body.style.left = vm.modalLockBodyLeft;
      body.style.right = vm.modalLockBodyRight;
      body.style.width = vm.modalLockBodyWidth;
    }
  }
  if (vm.modalLockBodyIsFixed) {
    window.scrollTo(0, vm.modalLockBodyScrollY);
  }
  vm.modalLockWrapper = null;
  vm.modalLockWrapperTransform = "";
  vm.modalLockWrapperWebkitTransform = "";
  vm.modalLockMainPanel = null;
  vm.modalLockMainPanelOverflow = "";
  vm.modalLockMainPanelScrollTop = 0;
  vm.modalLockMainPanelTransform = "";
  vm.modalLockMainPanelWebkitTransform = "";
  vm.modalLockBodyOverflow = "";
  vm.modalLockBodyPosition = "";
  vm.modalLockBodyTop = "";
  vm.modalLockBodyLeft = "";
  vm.modalLockBodyRight = "";
  vm.modalLockBodyWidth = "";
  vm.modalLockBodyScrollY = 0;
  vm.modalLockBodyIsFixed = false;
  vm.isModalScrollLocked = false;
}
